// // import thunk from "redux-thunk";
// import { createStore } from "redux";
import RootReducer from "./reducers/RootReducer";

// const initialState = {};
// // const middlewares = [thunk];
// // let devtools = (x) => x;

// export const Store = createStore(
//   RootReducer,
//   initialState,
//   // compose(applyMiddleware(...middlewares), devtools)
// );

// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

export const Store = configureStore({
  reducer: RootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk]
})

export const persistor = persistStore(Store)